module.exports = __webpack_public_path__ + "static/Heroku-2fc48145af42b4a48bb5eff40ac6b9a1.png";